import TechnicalRow from "./TechnicalRow"


export default function TechnicalInfoSection({ technicalInfo }) {
  return (
    <div className="space-y-4">
      <div className="bg-[#1F3A60] text-white p-4 rounded-lg">
        <h2 className="text-lg md:text-xl font-semibold">{technicalInfo.title}</h2>
      </div>

      <div className="bg-white rounded-lg border-2 border-gray-200 shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <tbody>
              {technicalInfo.data.map((row, i) => (
                <TechnicalRow
                  key={i}
                  leftLabel={row.left.label}
                  leftValue={row.left.value}
                  leftSubtitle={row.left.subtitle}
                  leftAdditionalInfo={row.left.additionalInfo}
                  leftMeasurements={row.left.measurements}
                  rightLabel={row.right.label}
                  rightValue={row.right.value}
                  rightAdditionalInfo={row.right.additionalInfo}
                  rightMeasurements={row.right.measurements}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
